import * as React from "react";
import {PieChartWithLabels} from "../../../../../../dashboard/widgets/charts/PieChartWithLabels";
import {Legend, LegendItem} from "../../../../../../components/charts/Legend";
import {CoffeeConsumptionByType} from "../../../data/CoffeeMachineJsonMapper";
import {JSONDispensingTimeAvgWidgetTexts, JSONWidgetTexts} from "../../CoffeeMachineDashboard";
import {processConsumptionData} from "./CoffeeMachineWidgetUtils";
import {Widget, WidgetProps} from "./Widget";

import {CUNSUMPTION_FILTER_EVENT} from "./ContinueDispensingConsumptionsWidget";
import {VeBoxCard} from "../../../../../../components/card/VeBoxCard";
import AutoSizer from "react-virtualized-auto-sizer";

interface PieChartWidgetProps<J extends JSONWidgetTexts> extends WidgetProps {
    texts: J;
    data: CoffeeConsumptionByType[];
    thresholds: number[];
    type: string;
}

interface PieChartWidgetState {
    selectedItemName: string;
    consumptionFilter: boolean;
}

export class PieChartWidget<J extends JSONWidgetTexts> extends Widget<PieChartWidgetProps<J>, PieChartWidgetState> {

    constructor(props: PieChartWidgetProps<J>) {
        super(props);
        this.state = {
            selectedItemName: null,
            consumptionFilter: null,
        };
    }

    public componentDidMount() {
        this.listener = this.props.controller.listen(({type, data}) => {
            if (type === CUNSUMPTION_FILTER_EVENT) {
                this.setState({
                    consumptionFilter: data,
                });
            }
        });
    }

    public widgetRender() {
        const widgetTexts = this.props.texts as unknown as JSONDispensingTimeAvgWidgetTexts;
        const legendItems: LegendItem[] = [
            {color: "rgba(246, 76, 72, 1)", name: widgetTexts.legendItems[0], value: 1},
            {color: "rgba(105, 255, 79, 0.7)", name: widgetTexts.legendItems[1], value: 2},
            {color: "rgba(246, 125, 72, 1)", name: widgetTexts.legendItems[2], value: 3},
        ];

        const preparedData = processConsumptionData(
            this.props.data,
            this.props.thresholds,
            legendItems,
            this.state.consumptionFilter,
        );

        return (
            <VeBoxCard className={"no-margin"}>
                <VeBoxCard.Header title={this.props.texts.title}/>
                <VeBoxCard.Body className="continue-dispensing-consumptions-widget__content no-padding">
                    <div className="pie-chart__legend__container">
                        <Legend
                            items={legendItems}
                            selectedItemName={this.state.selectedItemName}
                            onItemHover={this.setSelectedItem}
                        />
                    </div>
                    <div className="pie-chart__graph">
                        <AutoSizer style={{width: "auto", height: "auto"}}>
                            {({height, width}) =>
                                <PieChartWithLabels
                                    donutOptions={{activeDonut: false}}
                                    width={width}
                                    height={height}
                                    radiusRatio={2}
                                    data={preparedData}
                                    showPercentage={true}
                                    showFrequency={false}
                                    showIcon={false}
                                    noDataMessage={"No data"}
                                    labelLineDefaultLength={20}
                                    order={"desc"}
                                    groupingThreshold={15}
                                    selectedItem={this.state.selectedItemName}
                                    labelsOptions={{externalLegend: true}}
                                    onPathOver={this.setSelectedItem}
                                />
                            }
                        </AutoSizer>
                    </div>
                </VeBoxCard.Body>
            </VeBoxCard>
        );
    }

    private setSelectedItem = (itemName) => {
        this.setState({
            selectedItemName: itemName,
        });
    }
}
